import { Routes } from '@angular/router';
import { Main } from './main/main';
import { AuthGuardService } from './shared/services/auth-guard-service';

export const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuardService],
    component: Main,
    children: [
      { path: '', redirectTo: 'forms-flow', pathMatch: 'full' },
      {
        path: 'forms-flow',
        loadChildren: () => import('./forms-flow/forms-flow-module').then((m) => m.FormsFlowModule),
      },
      {
        path: 'unit-manager/to-dispatch-forms/ut/:ut',
        loadComponent: () =>
          import('./unit-manager/to-dispatch-forms/to-dispatch-forms.component').then(
            (m) => m.ToDispatchFormsComponent,
          ),
      },
      {
        // ✅ 新增：匹配檢視表單的路徑
        // 注意：路徑必須與 navigate 傳入的陣列完全對應
        path: 'unit-manager/to-dispatch-forms/ut/:ut/sta/:sta/view/:formId',
        loadComponent: () =>
          import('./shared/components/form-viewer/form-viewer.component').then(
            (m) => m.FormViewerComponent,
          ),
      },
      {
        path: 'personal-lexicon',
        loadComponent: () =>
          import('./personal-lexicon/main/main.component').then(
            // 這裡多加一個 /main
            (m) => m.MainComponent,
          ),
      },
    ],
  },
];
